import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ValueStackSection } from './components/ValueStackSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { StickyFooter } from './components/StickyFooter';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-brand-200 selection:text-brand-900" data-id="element-0" data-mp="31c9y2cr4hfvo">
      <main data-id="element-1" data-mp="2wi5mthatqlos">
        <HeroSection data-id="element-2" data-mp="28ufoscpxzgjl" />
        <PainSection data-id="element-3" data-mp="28tmex2vosax8" />
        <SolutionSection data-id="element-4" data-mp="28t4kmbsl46ry" />
        <ValueStackSection data-id="element-5" data-mp="28sbcb6dz997p" />
        <BonusSection data-id="element-6" data-mp="23vkvuhy9gblr" />
        <PricingSection data-id="element-7" data-mp="23w4ek0vqj40u" />
        <TestimonialsSection data-id="element-8" data-mp="23utas12ahw9q" />
        <GuaranteeSection data-id="element-9" data-mp="23ti6m04xmmi3" />
        <FAQSection data-id="element-10" data-mp="3ikhaeg9qb525" />
      </main>
      <StickyFooter data-id="element-11" data-mp="3ijfwm41bw4gq" />
    </div>;
}